import { Component, OnInit } from '@angular/core';
import { ApiPartnerService } from '../../api/api-partner.service';
import { ActivatedRoute, Router } from '@angular/router';
import { URLSearchParams } from '@angular/http';
import { $$iterator } from 'rxjs/internal/symbol/iterator';
import { AuthenticationService } from '@app/_services/authentication.service';


@Component({
  selector: 'app-listorder',
  templateUrl: './listorder.component.html',
  styleUrls: ['./listorder.component.css']
})
export class ListOrderComponent implements OnInit {
  constructor(public partnerService: ApiPartnerService,
    private route: ActivatedRoute,
    private router: Router,
    private Auth: AuthenticationService,
  ) {
  }

  orders: any = {};
  paging: any = {};
  msearch: string;
  pageSelf = [];
  pageNext = [];
  pagePrev = [];
  lastIndex: number;
  firstIndex: number;
  totalCount: number;
  querySearch = false;
  searching = false;
  dataEmpty = true;
  currentParams = {};
  queryParams = '';
  searchQueryParams = '';
  tableLoad = true;
  meta = [];
  role: any = "";
  permision: string[] = [];
  currentuser: any = {};

  ngOnInit(): void {
    this.loadOrders();
    this.currentuser = this.Auth.currentUserValue;
    this.cekuser();
    this.permision = this.currentuser.permision;
  }

  cekuser() {
    const currentUser: any = this.Auth.currentUserValue;
    if (currentUser != null) {
      if (currentUser.role.roleName) {
        this.role = currentUser.role.roleName;
      }
    }
  }

  MyPermission(p) {
    if (this.permision.indexOf(p) > -1) {
      return true;
    } else {
      return false;
    }
  }

  refreshPage() {
    this.loadOrders();
  }

  loadOrders() {
    this.route.queryParams
      .subscribe(params => {
        if (params.search !== '' && params.search !== undefined) {
          this.msearch = params.search;
          this.querySearch = true;
          this.currentParams = params;
          this.queryParams = '?' + this.queryStr(params);
          this.fetchOrders(this.queryParams);
        } else {
          this.querySearch = false;
          this.currentParams = params;
          this.queryParams = '?' + this.queryStr(params);
          this.fetchOrders(this.queryParams);
        }
      });
  }

  queryStr(options) {
    const params = new URLSearchParams();
    for (const key in options) {
      if (Object.prototype.hasOwnProperty.call(options, key)) {
        params.set(key, options[key]);
      }
    }
    return params.toString();
  }

  search() {
    this.querySearch = true;
    this.searchQueryParams = this.queryParams + '&search=' + this.msearch;
    this.fetchOrders(this.searchQueryParams);
  }

  fetchOrders(params) {
    this.tableLoad = true;
    return this.partnerService.GetNextsysOrder(params).subscribe((output: any) => {
      this.orders = output.data;
      this.tableLoad = false;

      this.paging = output.pagex;
      this.pageSelf = output.pagex.self;
      this.pageNext = output.pagex.next;
      this.pagePrev = output.pagex.prev;
      this.meta = output.meta;
      // tslint:disable-next-line:no-string-literal
      this.totalCount = this.meta['totalCount'];
      // tslint:disable-next-line:no-string-literal
      const self = this.pageSelf['page'];
      // tslint:disable-next-line:no-string-literal
      if (self * this.meta['perPage'] < this.meta['totalCount']) {
        // tslint:disable-next-line:no-string-literal
        this.lastIndex = (self * this.meta['perPage']);
      } else {
        // tslint:disable-next-line:no-string-literal
        this.lastIndex = this.meta['totalCount'];
      }

      // tslint:disable-next-line:no-string-literal
      this.firstIndex = ((self - 1) * this.meta['perPage']) + 1;
    });
  }

  protected readonly $$iterator = $$iterator;
}

